import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Nav from "../main/nav";
import Footer from "../main/footer";
import DateRange from "../main/DateRange";
import { use } from "react";
import axios from "axios";
import ExportHeader from "../main/ExportHeader";
import Swal from "sweetalert2";
import DownloadExcel from "../main/DownloadExcel";
import { formatToDateTime } from "../main/formatToDateTime";

export default function ImportReports() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [type, setType] = useState(searchParams.get("type") || "carting");
  const [start, setStart] = useState(searchParams.get("start") || "");
  const [end, setEnd] = useState(searchParams.get("end") || "");
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(1);
  const [CrnNo, setCrnNo] = useState(null);
  const [warehouseName, setWarehouseName] = useState("");
  const [fcl_lcl, setFclLcl] = useState("");

  const handleFromSubmit = (e) => {
    e.preventDefault();
    setCrnNo(e.target.crn_no.value);
    let range = e.target.range?.value;
    if (range) {
      let [startDateTime, endDateTime] = range.split(" ~ ");
      setStart(startDateTime);
      setEnd(endDateTime);
      console.log("range", range);
    }
    setWarehouseName(e.target.warehouse_name.value);
    setFclLcl(e.target.type.value);
  };

  const DownLoadData = async () => {
    const transformations = [];
    const columnsToDelete = [
      "rn",
      "id",
      "is_cargo_card_generated",
      "reserve_flag",
      "container_number",
      "container_type",
      "container_size",
      "container_life",
      "cncl_flag",
      "private_or_concor_labour_flag",
      "status",
      "updated_at",
      "created_at",
      "created_by",
      "integration_flag",
      "read_flag",
      "status_flag",
      "cycle_flag",
    ];
    const fileName = type.toUpperCase();

    try {
      let allData = [];
      let currentPage = 1;
      let totalPages = 1;

      do {
        const response = await fetch(
          `https://ctas.live/backend/api/${type}/transaction?page=${currentPage}`
        );
        const result = await response.json();

        if (result.status === "success") {
          allData = [...allData, ...result.data.data];
          totalPages = result.data.last_page;
        }
        currentPage++;
      } while (currentPage <= totalPages);

      DownloadExcel(allData, columnsToDelete, fileName, transformations);
    } catch (error) {
      console.error("Error fetching all data:", error);
    }
  };

  useEffect(() => {
    GetData();
  }, [type, CrnNo, start, end, warehouseName, fcl_lcl]);

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `https://ctas.live/backend/api/${type}/transaction?page=${page}`;
    if (CrnNo) {
      url += `&crn_number=${CrnNo}`;
    }
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }
    if (warehouseName) {
      url += `&warehouse_name=${warehouseName}`;
    }
    if (fcl_lcl) {
      url += `&type=${fcl_lcl}`;
    }
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          // access_token: `${AccessToken}`,
        },
      });
      if (response.data && response.data) {
        console.log("all data receve", response.data.data);
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..!`,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <ExportHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row my-3">
                  <div className="nav-align-top">
                    <ul className="nav nav-pills  flex-md-row gap-2 gap-lg-0">
                      <li
                        className="nav-item"
                        onClick={() => {
                          setType("carting");
                        }}
                      >
                        <p
                          className={`nav-link border ${
                            type == "carting" ? "active" : ""
                          } waves-effect waves-light`}
                        >
                          Carting
                        </p>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() => {
                          setType("stuffing");
                        }}
                      >
                        <p
                          className={`nav-link border ${
                            type == "stuffing" ? "active" : ""
                          } waves-effect waves-light`}
                        >
                          Stuffing
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between my-3">
                  <div className="card">
                    <div className="card-body">
                      <form
                        className="needs-validation"
                        noValidate=""
                        onSubmit={handleFromSubmit}
                      >
                        <div className="row">
                          {/* CRN NO */}
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-6">
                              <input
                                type="text"
                                name="crn_no"
                                className="form-control"
                                placeholder={`CRN ${
                                  type == "stuffing" && "/CTR "
                                } NO.`}
                                value={CrnNo}
                                onChange={(e) => setCrnNo(e.target.value)}
                              />
                              <label className="form-label" htmlFor="crn_no">
                                CRN {type == "stuffing" && "/CTR "} No.
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline mb-6">
                              <DateRange />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-6">
                              <select
                                name="warehouse_name"
                                className="form-select"
                                value={warehouseName}
                                onChange={(e) =>
                                  setWarehouseName(e.target.value)
                                }
                              >
                                <option value="">All</option>
                                <option value="Export">
                                  Export (Gate 10 till Gate 13)
                                </option>
                                <option value="Mazzanine">
                                  Mazzanine (Gate 6 till Gate 9)
                                </option>
                                <option value="OYCA">OYCA</option>
                                <option value="OYCB">OYCB</option>
                                <option value="OYCC">OYCC</option>
                                <option value="OYCD">OYCD</option>
                              </select>
                              <label
                                className="form-label"
                                htmlFor="warehouse_name"
                              >
                                Warehouse Name
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-6">
                              <select
                                name="type"
                                className="form-select"
                                value={type}
                                onChange={(e) => setFclLcl(e.target.value)}
                              >
                                <option value="">Select Type</option>
                                <option value="FCL">FCL</option>
                                <option value="LCL">LCL</option>
                              </select>
                              <label className="form-label" htmlFor="type">
                                Type
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4 d-flex align-items-center gap-2">
                            <button
                              type="submit"
                              className="btn btn-label-primary"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            <a
                              href="?"
                              type="button"
                              className="btn btn-label-primary"
                            >
                              <i className="ri-restart-line ri-20px" />
                            </a>
                            <button
                              type="button"
                              className="btn btn-label-primary"
                              onClick={() => DownLoadData()}
                            >
                              <i className="ri-download-fill"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        {type == "carting" ? (
                          <table className="table table-hover table-striped table-sm">
                            <thead>
                              <tr className="table-primary">
                                <td>SN</td>
                                <td>Type</td>
                                <td>CRN No</td>
                                <td>Port</td>
                                <td>Package Weight</td>
                                <td>No Of Package</td>
                                <td>Sline Code</td>
                                <td>Truck No</td>
                                <td>Sbill Number</td>
                                <td>Grid Area</td>
                                <td>Start DateTime</td>
                                <td>End DateTime</td>
                                <td>Handling Type</td>
                                <td>Exporter Name</td>
                                <td>Cha Code</td>
                              </tr>
                            </thead>
                            <tbody>
                              {Data?.data?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.rn} </td>
                                  <td>{item.type}</td>
                                  <td>
                                    {item.crn_number}{" "}
                                    <Link
                                      to={`/carting/tallySheet?id=${item.id}&crn_number=${item.crn_number}`}
                                    >
                                      <i className="ri-eye-line ri-22px"></i>
                                    </Link>
                                  </td>
                                  <td>{item.gw_port_code}</td>
                                  <td>
                                    {item.carting_trucks
                                      ?.reduce(
                                        (total, detail) =>
                                          total +
                                          (parseFloat(detail.pkgs_weight) || 0),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td>
                                    {item.carting_trucks?.reduce(
                                      (total, detail) =>
                                        total +
                                        (Number(detail.no_of_pkgs) || 0),
                                      0
                                    )}
                                  </td>
                                  <td>{item?.shipping_liner_code}</td>
                                  <td>
                                    {[
                                      ...new Set(
                                        item?.carting_trucks?.map(
                                          (truck) => truck?.truck_number
                                        )
                                      ),
                                    ]?.map((truck_number) => (
                                      <span className="d-block">
                                        {truck_number}
                                      </span>
                                    ))}
                                  </td>
                                  <td>
                                    {[
                                      ...new Set(
                                        item?.carting_trucks?.map(
                                          (truck) => truck?.sbill
                                        )
                                      ),
                                    ]?.map((bill) => (
                                      <span className="d-block">{bill}</span>
                                    ))}
                                  </td>
                                  <td>
                                    {item?.carting_trucks?.map((details, i) =>
                                      details?.grid_area?.map((grid, k) => {
                                        const oycList = [
                                          "OYCA",
                                          "OYCB",
                                          "OYCC",
                                          "OYCD",
                                        ];
                                        const isWarehouseOYC =
                                          oycList.includes(warehouseName);
                                        const isGridOYC = oycList.includes(
                                          grid?.grid_locations
                                        );

                                        // CASE 1: Only show matching OYC grid
                                        if (isWarehouseOYC) {
                                          if (
                                            grid?.grid_locations ===
                                            warehouseName
                                          ) {
                                            return (
                                              <small
                                                key={`${i}-${k}`}
                                                className="d-block"
                                              >
                                                {grid?.grid_locations}:{" "}
                                                {grid?.area}
                                              </small>
                                            );
                                          }
                                          return null; // don't show other OYC grids
                                        }

                                        // CASE 2: Non-OYC warehouseName (e.g., Export, Mazzanine) → show non-OYC grids only
                                        if (warehouseName && !isWarehouseOYC) {
                                          if (!isGridOYC) {
                                            return (
                                              <small
                                                key={`${i}-${k}`}
                                                className="d-block"
                                              >
                                                {grid?.grid_locations}:{" "}
                                                {grid?.area}
                                              </small>
                                            );
                                          }
                                          return null; // skip OYC grids
                                        }

                                        // CASE 3: warehouseName is not provided → show all
                                        return (
                                          <small
                                            key={`${i}-${k}`}
                                            className="d-block"
                                          >
                                            {grid?.grid_locations}: {grid?.area}
                                          </small>
                                        );
                                      })
                                    )}
                                  </td>

                                  <td>{formatToDateTime(item.start_time)}</td>
                                  <td>{formatToDateTime(item.end_time)}</td>
                                  <td>{item?.handline_type}</td>
                                  <td>{item?.exporter_name}</td>
                                  <td>{item?.cha_code}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <table className="table table-hover table-striped table-sm ">
                            <thead>
                              <tr className="table-primary">
                                <td>SN</td>
                                <td>Type</td>
                                <td>CRN No</td>
                                <td>Container No</td>
                                <td>Container Size</td>
                                <td>Port</td>
                                <td>Package Weight</td>
                                <td>No Of Package</td>
                                <td>Sbill Number</td>
                                <td>Grid Area</td>
                                <td>Start DateTime</td>
                                <td>End DateTime</td>
                                <td>Handling Type</td>
                                <td>Cha Code</td>
                              </tr>
                            </thead>
                            <tbody>
                              {Data?.data?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.rn}</td>
                                  <td>{item.type}</td>
                                  <td>
                                    {item.crn_number}{" "}
                                    <Link
                                      to={`/stuffing/tallySheet?id=${item.id}&type=${item.type}&container_number=${item.container_number}`}
                                    >
                                      <i className="ri-eye-line ri-22px"></i>
                                    </Link>
                                  </td>
                                  <td>{item.container_number}</td>
                                  <td>{item.container_size}</td>
                                  <td>{item.gw_port}</td>
                                  <td>
                                    {item.stuffing_shipping_bill_details
                                      ?.reduce(
                                        (total, detail) =>
                                          total +
                                          (parseFloat(detail.package_weight) ||
                                            0),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td>
                                    {item.stuffing_shipping_bill_details?.reduce(
                                      (total, detail) =>
                                        total +
                                        (Number(
                                          detail.no_of_packages_declared
                                        ) || 0),
                                      0
                                    )}
                                  </td>
                                  <td>
                                    {item?.stuffing_shipping_bill_details?.map(
                                      (bills, i) => (
                                        <span key={i} className="d-block">
                                          {bills.shipping_bill_number} ,
                                        </span>
                                      )
                                    )}
                                  </td>

                                  <td>
                                    {item?.stuffing_shipping_bill_details?.map((details, i) =>
                                      details?.grid_area?.map((grid, k) => {
                                        const oycList = [
                                          "OYCA",
                                          "OYCB",
                                          "OYCC",
                                          "OYCD",
                                        ];
                                        const isWarehouseOYC =
                                          oycList.includes(warehouseName);
                                        const isGridOYC = oycList.includes(
                                          grid?.grid_locations
                                        );

                                        // CASE 1: Only show matching OYC grid
                                        if (isWarehouseOYC) {
                                          if (
                                            grid?.grid_locations ===
                                            warehouseName
                                          ) {
                                            return (
                                              <small
                                                key={`${i}-${k}`}
                                                className="d-block"
                                              >
                                                {grid?.grid_locations}:{" "}
                                                {grid?.area}
                                              </small>
                                            );
                                          }
                                          return null; // don't show other OYC grids
                                        }

                                        // CASE 2: Non-OYC warehouseName (e.g., Export, Mazzanine) → show non-OYC grids only
                                        if (warehouseName && !isWarehouseOYC) {
                                          if (!isGridOYC) {
                                            return (
                                              <small
                                                key={`${i}-${k}`}
                                                className="d-block"
                                              >
                                                {grid?.grid_locations}:{" "}
                                                {grid?.area}
                                              </small>
                                            );
                                          }
                                          return null; // skip OYC grids
                                        }

                                        // CASE 3: warehouseName is not provided → show all
                                        return (
                                          <small
                                            key={`${i}-${k}`}
                                            className="d-block"
                                          >
                                            {grid?.grid_locations}: {grid?.area}
                                          </small>
                                        );
                                      })
                                    )}
                                  </td>
                                  <td>{formatToDateTime(item.start_time)}</td>
                                  <td>{formatToDateTime(item?.end_time)}</td>
                                  <td>{item?.handling_type}</td>
                                  <td>{item?.cha_code}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}

                        {Data && Data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {Data.from} to {Data.to} of{" "}
                                  {Data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {Data &&
                                      Data.links &&
                                      Data?.links?.map((link, q) => {
                                        let showData =
                                          Data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                            ? "Previous"
                                            : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${
                                              link.active === true
                                                ? "active"
                                                : ""
                                            }  ${
                                              showData == "Next" &&
                                              Data.current_page ==
                                                Data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  Data.current_page == 1
                                                ? "disabled"
                                                : ""
                                            } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                      Data.current_page - 1
                                                    )
                                                  : showData == "Next"
                                                  ? GetData(
                                                      Data.current_page + 1
                                                    )
                                                  : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
